import React, { Component } from 'react';
import { Icon } from "semantic-ui-react";
import moment from "moment";
import { adpLink } from "../../constants"
import { showFinancialNotesTable, showTedCollectionsTable } from "./functions";
import { formatCurrency } from '../../utils/commonutils';

class CollectionsOffset extends Component {
    render() {
        const { providerData, startDate, earnings, details, payDetails, currentPeriod, getPracticeName } = this.props;
        const {
            numberOfWorkedDays, patientVisits, patientVisitsPerDay, contractType,
            dentistWorkTimeType, prodAdjWo, doctorPayVariables,
            sortName, financialNoteList, financialNotes, offset, data: practiceData
        } = providerData;

        const annualizedPay = earnings * (currentPeriod != null ? 24 : 12);
        const dailyRatePay = numberOfWorkedDays ? (earnings / numberOfWorkedDays) : 0;
        const { payChecks, hygData, collectionsList } = details;

        const totalCollections = Array.isArray(collectionsList)
            ? collectionsList.reduce((sum, c) => sum + (c.Amount || 0), 0)
            : 0;

        const offsetPercent = offset ?? doctorPayVariables?.Offset ?? doctorPayVariables?.offset ?? 0;
        const offsetDeduction = totalCollections * offsetPercent * 0.01;
        const collectionsAfterOffset = Math.max(0, totalCollections - offsetDeduction);
        const guaranteedBasePay = doctorPayVariables?.monthlyBasePay || 0;

        const payDayValue = currentPeriod
            ? currentPeriod.paidOn
            : moment(startDate).add(1, 'months').format('MMMM YYYY');
        const workPeriodValue = currentPeriod
            ? currentPeriod.displayRange
            : moment(startDate).format('MMMM YYYY');

        return (
            <div>
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>{sortName}</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>{currentPeriod != null ? 'Pay Day' : 'Pay Month'}</p>
                                        <p>{payDayValue}</p>
                                    </li>
                                    <li>
                                        <p>{currentPeriod != null ? 'Work Period' : 'Work Month'}</p>
                                        <p>{workPeriodValue}</p>
                                    </li>
                                    <li>
                                        <p>Work Days</p>
                                        <p>{numberOfWorkedDays}</p>
                                    </li>
                                    <li>
                                        <p>{currentPeriod != null ? 'Work Base Pay' : 'Work Month Base Pay'}</p>
                                        <p>{formatCurrency(guaranteedBasePay)}</p>
                                    </li>
                                    <li>
                                        <p>Total Collections</p>
                                        <p>{formatCurrency(totalCollections)}</p>
                                    </li>
                                    <li>
                                        <p>Offset %</p>
                                        <p>{offsetPercent}%</p>
                                    </li>
                                    <li>
                                        <p>Collections After Offset</p>
                                        <p>{formatCurrency(collectionsAfterOffset)}</p>
                                    </li>
                                    <li>
                                        <p>{currentPeriod != null ? 'Total Earnings' : 'Total Month Earnings'}</p>
                                        <p>{formatCurrency(earnings)}</p>
                                    </li>
                                    <li>
                                        <p>Annualized Earnings</p>
                                        <p>{formatCurrency(annualizedPay)}</p>
                                    </li>
                                    <li>
                                        <p>Avg Daily Earnings</p>
                                        <p>{formatCurrency(dailyRatePay)}</p>
                                    </li>
                                    <li>
                                        <p>Pt Visits</p>
                                        <p>{patientVisits}</p>
                                    </li>
                                    <li>
                                        <p>Pt Visits/ Day</p>
                                        <p>{patientVisitsPerDay}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Contract Details in first column when currentPeriod is null */}
                        {currentPeriod == null && (
                            <div className="ui card reports-card">
                                <div className="content">
                                    <h5>Contract Details</h5>
                                    <ul className="data-list">
                                        <li>
                                            <p>Contract Type</p>
                                            <p>{contractType}</p>
                                        </li>
                                        <li>
                                            <p>Monthly Base Work Days</p>
                                            <p>{doctorPayVariables.monthlyBaseWorkDays}</p>
                                        </li>
                                        <li>
                                            <p>Day Rate</p>
                                            <p>{formatCurrency(doctorPayVariables.dailyRatePay)}</p>
                                        </li>
                                        {Object.entries(practiceData || {}).map(([key, p]) => (
                                            <li key={key}>
                                                <p>{p.practiceInfo?.[0]?.practice || key}</p>
                                                <p>{p.practicePayOverBase}%</p>
                                            </li>
                                        ))}
                                        <li>
                                            <p>Gross to Billable Adjustment %</p>
                                            <p>{100 - prodAdjWo}</p>
                                        </li>
                                        <li>
                                            <p>Work Status</p>
                                            <p>{dentistWorkTimeType}</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="col-12 col-md-6 col-lg-4">
                        {currentPeriod != null && (
                            <div className="ui card reports-card">
                                <div className="content">
                                    <h5>Contract Details</h5>
                                    <ul className="data-list">
                                        <li>
                                            <p>Contract Type</p>
                                            <p>{contractType}</p>
                                        </li>
                                        <li>
                                            <p>Base Work Days</p>
                                            <p>{doctorPayVariables.monthlyBaseWorkDays}</p>
                                        </li>
                                        <li>
                                            <p>Day Rate</p>
                                            <p>{formatCurrency(doctorPayVariables.dailyRatePay)}</p>
                                        </li>
                                        {Object.entries(practiceData || {}).map(([key, p]) => (
                                            <li key={key}>
                                                <p>{p.practiceInfo?.[0]?.practice || key}</p>
                                                <p>{p.practicePayOverBase}%</p>
                                            </li>
                                        ))}
                                        <li>
                                            <p>Gross to Billable Adjustment %</p>
                                            <p>{100 - prodAdjWo}</p>
                                        </li>
                                        <li>
                                            <p>Work Status</p>
                                            <p>{dentistWorkTimeType}</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        )}

                        {/* Friday Gross Earnings in second column only when currentPeriod is null */}
                        {currentPeriod == null && (
                            <div className="ui card reports-card">
                                <div className="content">
                                    {payChecks && Object.entries(payChecks).map(([date, dateChecks], i) => (
                                        <div key={i}>
                                            <div className="d-flex justify-content-between flex-wrap">
                                                <h5 className="mr10">{i + 1}{(1 + i) === 1 ? 'st' : 'nd'} Friday Gross Earnings Pre-Tax</h5>
                                                <strong className="secondaryColor text-right">{date}</strong>
                                            </div>
                                            <table className="table table-striped table-hover table-sm mt-0 mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>OFFICE</th>
                                                        <th className="text-right">EARNINGS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dateChecks.officeChecks.map((office, idx) => (
                                                        <tr key={idx}>
                                                            <td>{getPracticeName ? getPracticeName(office.practice) : office.practice}</td>
                                                            <td className="text-right">{formatCurrency(office.check)}</td>
                                                        </tr>
                                                    ))}
                                                    <tr>
                                                        <td><strong>Total</strong></td>
                                                        <td className="text-right">
                                                            <strong>{formatCurrency(dateChecks.total)}</strong>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Accessing Your Pay Stub</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Link to ADP</p>
                                        <p>
                                            <a href={adpLink} target={'_blank'} rel="noreferrer">
                                                <Icon name='external alternate' className="primaryColor" />
                                            </a>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row"></div>
                {showFinancialNotesTable(financialNoteList, financialNotes)}
                {showTedCollectionsTable(details.payDetailsList)}
                <div className="table-responsive">
                    <h5>Pay Details</h5>
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th><div>SERVICE DATE</div></th>
                                <th><div>PRACTICE</div></th>
                                <th><div>GROSS CARE</div></th>
                                <th><div>ADJUSTMENT</div></th>
                                <th><div>WRITE OFF</div></th>
                                <th><div>COLLECTIONS</div></th>
                                <th><div>FINANCIAL NOTES</div></th>
                                <th><div>EARNINGS</div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {payDetails}
                            {payDetails.length < 1 && (
                                <tr key="payDetailsRowTotal">
                                    <td colSpan={8}><strong>No records found</strong></td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default CollectionsOffset;
